import { render, staticRenderFns } from "./AppModalHeader.vue?vue&type=template&id=234e7c35&scoped=true&"
import script from "./AppModalHeader.vue?vue&type=script&lang=js&"
export * from "./AppModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppModalHeader.vue?vue&type=style&index=0&id=234e7c35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234e7c35",
  null
  
)

export default component.exports